import { useState } from "react";
import { Stack, Typography } from "@mui/material";
import { AppModalDialogBox } from "../../../../components/modals";
import { SaveAndCancelButton } from "../../../../components/buttons";
import {
  addClientCampaign,
  updateClientCampaign,
} from "../../../../apis/clients.api";
import { useDispatch } from "react-redux";
import { LabelAndValue } from "../../../../components/typography";
import { numberFormat } from "../../../../services/utils";
import { ENUM_CURRENCY } from "../../../../enums";
import { AppTextField } from "../../../../components/textfields";
import { AppDatePicker } from "../../../../components/datepickers";

function AddCampaignModal({ selectedClient, campaign, handleModalClose }) {
  const isEdit = campaign?.index !== undefined;
  const dispatch = useDispatch();
  const [budget, setBudget] = useState(
    campaign?.budget !== undefined ? String(campaign.budget) : ""
  );
  const [meetings, setMeetings] = useState(
    campaign?.meetings !== undefined ? String(campaign.meetings) : ""
  );
  const [date, setDate] = useState(
    campaign?.date ? new Date(campaign.date) : new Date()
  );
  const [label, setLabel] = useState(campaign?.label || "");
  const [errors, setErrors] = useState({
    budget: "",
    meetings: "",
  });

  const onSubmit = async () => {
    const nextErrors = {
      budget: budget === "" ? "Please enter a budget" : "",
      meetings: meetings === "" ? "Please enter meetings" : "",
    };

    if (nextErrors.budget || nextErrors.meetings) {
      setErrors(nextErrors);
      return;
    }

    const payload = {
      budget: Number(budget),
      meetings: Number(meetings),
      date: date ? new Date(date).toISOString() : undefined,
      label: label.trim(),
    };

    const response: any = isEdit
      ? await dispatch(
          updateClientCampaign(selectedClient?.id, campaign.index, payload)
        )
      : await dispatch(addClientCampaign(selectedClient?.id, payload));

    if (response.success) {
      handleModalClose();
    }
  };

  return (
    <AppModalDialogBox
      isModalOpen={true}
      title={isEdit ? "Edit Campaign" : "Add Campaign"}
      handleClose={handleModalClose}
      maxHeight={600}
      actionButtonRenderer={
        <SaveAndCancelButton
          primaryText={isEdit ? "Update" : "Submit"}
          defaultText={"Cancel"}
          onPrimaryActionClick={onSubmit}
          onDefaultButtonClick={handleModalClose}
        />
      }
      size={"sm"}
    >
      <Stack gap={2}>
        <LabelAndValue
          label="Current Budget"
          value={numberFormat(selectedClient?.budget, ENUM_CURRENCY.USD)}
        />
        <AppTextField
          id={"budget"}
          name={"budget"}
          label={"Budget *"}
          onChange={(e) => {
            setBudget(e.target.value);
            setErrors({ ...errors, budget: "" });
          }}
          value={budget}
          error={errors.budget}
          autoComplete={"off"}
        />
        <AppTextField
          id={"meetings"}
          name={"meetings"}
          label={"Meetings *"}
          onChange={(e) => {
            setMeetings(e.target.value);
            setErrors({ ...errors, meetings: "" });
          }}
          value={meetings}
          error={errors.meetings}
          autoComplete={"off"}
        />
        <Stack>
          <Typography fontSize={14} fontWeight={400}>
            Date *
          </Typography>
          <AppDatePicker
            selectedDate={date}
            setDate={setDate}
            dateFormat="MMM d, yyyy"
          />
        </Stack>
        <AppTextField
          id={"label"}
          name={"label"}
          label={"Label"}
          onChange={(e) => setLabel(e.target.value)}
          value={label}
          autoComplete={"off"}
        />
      </Stack>
    </AppModalDialogBox>
  );
}

export { AddCampaignModal };
